import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/kulioner-must-buy.svg'
import _imports_1 from '@/app/ui/assets/svg/kulioner-was-buy.svg'
import _imports_2 from '@/app/ui/assets/svg/kulioner-not-buy.svg'
import _imports_3 from '@/app/ui/assets/svg/exclamation-triangle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5d89bf8c")

_pushScopeId("data-v-5d89bf8c")
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-800 mb-2 text-12px" }, "Pastikan pesanan telah sesuai, karena pesanan tidak dapat diubah setelah diupdate", -1)
const _hoisted_3 = { class: "text-gray-lp-300 text-14px bg-gray-lp-200 justify-center items-center rounded-xl px-4 py-2" }
const _hoisted_4 = { class: "grid grid-cols-3 pt-2 gap-2" }
const _hoisted_5 = { class: "col-span-1 flex flex-row bg-gradient-to-r from-blue-100 via-gray-lp-100 to-gray-lp-100 p-4 rounded-xl border border-blue-lp-100 border-opacity-20 items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-8 h-8 mr-2",
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-800 text-12px whitespace-nowrap" }, "Harus Dibeli", -1)
const _hoisted_9 = { class: "text-left font-semibold text-20px" }
const _hoisted_10 = { class: "col-span-1 flex flex-row bg-gradient-to-r from-green-100 via-gray-lp-100 to-gray-lp-100 p-4 rounded-xl border border-green-lp-100 border-opacity-20 items-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-8 h-8 mr-2",
  alt: ""
}, null, -1)
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-800 text-12px whitespace-nowrap" }, "Sudah Dibeli", -1)
const _hoisted_14 = { class: "text-left font-semibold text-20px" }
const _hoisted_15 = { class: "col-span-1 flex flex-row bg-gradient-to-r from-red-100 via-gray-lp-100 to-gray-lp-100 p-4 rounded-xl border border-red-lp-100 border-opacity-20 items-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-8 h-8 mr-2",
  alt: ""
}, null, -1)
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-800 text-12px whitespace-nowrap" }, "kurang beli", -1)
const _hoisted_19 = { class: "text-left font-semibold text-20px" }
const _hoisted_20 = {
  key: 0,
  class: "flex flex-row items-center mt-2"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-6 h-6 mr-2",
  alt: ""
}, null, -1)
const _hoisted_22 = { class: "text-red-lp-100 text-12px text-left" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Status ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("kurang beli")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" akan masuk ke hari besok ")
const _hoisted_26 = { class: "flex flex-row items-center" }
const _hoisted_27 = { class: "p-field-checkbox mt-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "ml-2.5 text-12px text-left mt-2.5" }, " Saya setuju bahwa detail yang diperbarui sudah benar dan saya bertanggung jawab atas segala kesalahan ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_bold = _resolveComponent("bold")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_ModalV3 = _resolveComponent("ModalV3")!

  return (_openBlock(), _createBlock(_component_ModalV3, {
    modelValue: _ctx.modelValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue = $event)),
    image: "badge-confirmation-general",
    imageWidth: "24",
    imageHeight: "24",
    title: "Konfirmasi update pesanan?",
    customWidth: "520px"
  }, {
    custom: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_bold, { class: "font-bold" }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.merchantData.name), 1)
            ]),
            _: 1
          }),
          _createTextVNode(" (" + _toDisplayString(_ctx.merchantData.phoneNumber) + ") ", 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.summaryData.mustBuy), 1)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("span", _hoisted_14, _toDisplayString(_ctx.summaryData.wasBuy), 1)
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("span", _hoisted_19, _toDisplayString(_ctx.summaryData.notBuy), 1)
            ])
          ])
        ]),
        (!!_ctx.summaryData.notBuy)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _hoisted_21,
              _createVNode("p", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_bold, { class: "font-bold" }, {
                  default: _withId(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _hoisted_25
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode(_component_Checkbox, {
              id: "sender",
              modelValue: _ctx.isCheck,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCheck = $event)),
              binary: true
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_28
        ])
      ])
    ]),
    "custom-button": _withId(() => [
      _createVNode(_component_lp_button, {
        title: "Cek Kembali",
        textColor: "red-lp-100",
        color: "red-lp-100",
        outline: "",
        onClick: _ctx.close,
        isWidthFull: ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_lp_button, {
        title: "Ya, Update",
        textColor: "white",
        color: "red-lp-100",
        onClick: _ctx.confirm,
        disabled: !_ctx.isCheck,
        isWidthFull: ""
      }, null, 8, ["onClick", "disabled"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})